import { GridOutlineIc, MenuIc } from '@dsch/dd-icons';

import { GhostButton } from '../../../../components/Toolkit/Button';
import { LayoutSelectorProps } from '../../../../components/SearchPage/components/LayoutSelector/LayoutSelector.typed';

const LayoutSelector = (props: LayoutSelectorProps) => {
  const { viewType, setViewType } = props;
  const isListLayout = viewType === 'list';
  const nextViewType = isListLayout ? 'grid' : 'list';
  const ariaLabel = isListLayout
    ? 'Switch to grid view'
    : 'Switch to list view';
  const tooltip = isListLayout ? 'Grid View' : 'List View';

  return (
    <GhostButton
      size="SMALL"
      type="button"
      onClick={() => setViewType(nextViewType)}
      aria-label={ariaLabel}
      title={tooltip}
      data-tracking={`layout-${nextViewType}`}
    >
      {isListLayout ? (
        <GridOutlineIc width={20} height={20} />
      ) : (
        <MenuIc width={20} height={20} />
      )}
    </GhostButton>
  );
};

export { LayoutSelector };
